var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pkg2"},[_c('div',{staticClass:"unit1"},[_c('div',{staticClass:"unit1_inner"},[_vm._m(0),_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/top2020/img/comparison_table.webp'),expression:"'/top2020/img/comparison_table.webp'"}]})])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_vm._v(" 「着実に話せるようになる」という品質は"),_c('br'),_vm._v(" 結局、優れたコストパフォーマンスにつながります！ ")])
}]

export { render, staticRenderFns }